import { render, staticRenderFns } from "./FirstComponent.vue?vue&type=template&id=cb9bb846"
import script from "./FirstComponent.vue?vue&type=script&lang=js"
export * from "./FirstComponent.vue?vue&type=script&lang=js"
import style0 from "./FirstComponent.vue?vue&type=style&index=0&id=cb9bb846&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports